import cx from 'classnames'

type OverlayType = 'global' | 'local'
interface Props {
  onClick?: () => void
  className?: string
  bgColor?: string
  type?: OverlayType
  children?: React.ReactNode
}

function Overlay({
  type = 'global',
  onClick,
  className,
  children,
  bgColor = 'bg-gray-500',
}: Props) {
  return (
    <div
      data-testid="overlay"
      className={cx(
        `bg-opacity-75 transition-opacity z-30 flex justify-center items-center`,
        { 'absolute h-full w-full': type === 'local' },
        { 'fixed inset-0': type === 'global' },
        { 'cursor-pointer': onClick },
        className,
        bgColor
      )}
      onClick={onClick}
    >
      <div className="z-60">{children}</div>
    </div>
  )
}

export default Overlay
